var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "alert-log" },
    [
      _c("div", { staticClass: "page-header" }, [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "right" },
          [
            _c(
              "el-button",
              { attrs: { size: "small" }, on: { click: _vm.handleExport } },
              [
                _c("bi-label", {
                  attrs: { zh: "导出", pt: "Exportar", inline: "" },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-card",
        { staticClass: "filter-card", attrs: { shadow: "never" } },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.searchParam,
                "label-position": "top",
                size: "small",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("bi-label", {
                                attrs: {
                                  zh: "告警时间",
                                  pt: "Data do Alerta",
                                  inline: "",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "daterange",
                              "value-format": "yyyy-MM-dd",
                              "range-separator": "~",
                              "start-placeholder": "开始日期 / Início",
                              "end-placeholder": "结束日期 / Fim",
                            },
                            model: {
                              value: _vm.searchParam.params.time,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchParam.params, "time", $$v)
                              },
                              expression: "searchParam.params.time",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("bi-label", {
                                attrs: {
                                  zh: "告警类型",
                                  pt: "Tipo de Alerta",
                                  inline: "",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "全部 / Todos",
                                clearable: "",
                              },
                              model: {
                                value: _vm.searchParam.params.alertType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.searchParam.params,
                                    "alertType",
                                    $$v
                                  )
                                },
                                expression: "searchParam.params.alertType",
                              },
                            },
                            _vm._l(_vm.typeOptions, function (o) {
                              return _c("el-option", {
                                key: o.value,
                                attrs: {
                                  label: o.label + " / " + o.labelPt,
                                  value: o.value,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("bi-label", {
                                attrs: { zh: "UF", inline: "" },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "全部 / Todos",
                                clearable: "",
                                multiple: "",
                                filterable: "",
                                "collapse-tags": "",
                              },
                              model: {
                                value: _vm.searchParam.params.uf,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchParam.params, "uf", $$v)
                                },
                                expression: "searchParam.params.uf",
                              },
                            },
                            _vm._l(_vm.ufOptions, function (uf) {
                              return _c("el-option", {
                                key: uf.id,
                                attrs: { label: uf.label, value: uf.label },
                              })
                            }),
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("bi-label", {
                                attrs: {
                                  zh: "发送状态",
                                  pt: "Status do Envio",
                                  inline: "",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "全部 / Todos",
                                clearable: "",
                              },
                              model: {
                                value: _vm.searchParam.params.sendStatus,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.searchParam.params,
                                    "sendStatus",
                                    $$v
                                  )
                                },
                                expression: "searchParam.params.sendStatus",
                              },
                            },
                            _vm._l(_vm.statusOptions, function (o) {
                              return _c("el-option", {
                                key: o.value,
                                attrs: {
                                  label: o.label + " / " + o.labelPt,
                                  value: o.value,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("bi-label", {
                                attrs: {
                                  zh: "接收人",
                                  pt: "Destinatário",
                                  inline: "",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "全部 / Todos",
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.searchParam.params.recipientId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.searchParam.params,
                                    "recipientId",
                                    $$v
                                  )
                                },
                                expression: "searchParam.params.recipientId",
                              },
                            },
                            _vm._l(_vm.recipients, function (r) {
                              return _c("el-option", {
                                key: r.id,
                                attrs: { label: r.name, value: r.id },
                              })
                            }),
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "only-failed" },
                        [
                          _c("template", { slot: "label" }, [
                            _c("span", { staticClass: "ph-label" }),
                          ]),
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.searchParam.params.onlyFailed,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.searchParam.params,
                                    "onlyFailed",
                                    $$v
                                  )
                                },
                                expression: "searchParam.params.onlyFailed",
                              },
                            },
                            [
                              _c("bi-label", {
                                attrs: {
                                  zh: "只看失败",
                                  pt: "Somente falhas",
                                  inline: "",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "filter-btns" },
                        [
                          _c("template", { slot: "label" }, [
                            _c("span", { staticClass: "ph-label" }),
                          ]),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.applyFilter },
                            },
                            [
                              _c("bi-label", {
                                attrs: {
                                  zh: "查询",
                                  pt: "Consultar",
                                  inline: "",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: { click: _vm.resetFilter },
                            },
                            [
                              _c("bi-label", {
                                attrs: {
                                  zh: "重置",
                                  pt: "Redefinir",
                                  inline: "",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "table-card", attrs: { shadow: "never" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.tableLoading,
                  expression: "tableLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.pagedRows, border: "", size: "mini" },
            },
            [
              _c(
                "el-table-column",
                {
                  attrs: { "min-width": "180", "class-name": "cell-num" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [_vm._v(_vm._s(_vm.fmtLogTime(row)))]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("bi-label", {
                        attrs: { zh: "告警时间", pt: "Data do Alerta" },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { "min-width": "170" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "span",
                            {
                              staticClass: "tag",
                              class: _vm.typeCls(row.alertType),
                            },
                            [
                              _c("span", { staticClass: "dot" }),
                              _vm._v(_vm._s(_vm.typeZh(row.alertType)) + " "),
                              _c("span", { staticClass: "tag-pt" }, [
                                _vm._v(
                                  "/ " + _vm._s(_vm.typePt(row.alertType))
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("bi-label", {
                        attrs: { zh: "告警类型", pt: "Tipo de Alerta" },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { width: "70" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [_c("strong", [_vm._v(_vm._s(row.uf))])]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [_c("bi-label", { attrs: { zh: "UF" } })],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { "min-width": "300" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("div", { staticClass: "al-title" }, [
                            _vm._v(_vm._s(row.title || "—")),
                          ]),
                          _c("div", { staticClass: "al-content" }, [
                            _vm._v(_vm._s(row.content)),
                          ]),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("bi-label", {
                        attrs: { zh: "告警内容", pt: "Conteúdo do Alerta" },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { "min-width": "150" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [_vm._v(_vm._s(row.recipientName || "—"))]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("bi-label", {
                        attrs: { zh: "接收群", pt: "Grupo Destinatário" },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { width: "110" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _vm._v(" " + _vm._s(row.channel) + " "),
                          _c("span", { staticClass: "chan-pt" }, [
                            _vm._v(_vm._s(_vm.channelPt(row.channel))),
                          ]),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("bi-label", {
                        attrs: { zh: "发送渠道", pt: "Canal" },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { "min-width": "180" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "span",
                            {
                              staticClass: "tag",
                              class: _vm.statusCls(row.sendStatus),
                            },
                            [
                              _c("span", { staticClass: "dot" }),
                              _vm._v(
                                _vm._s(_vm.statusZh(row.sendStatus)) + " "
                              ),
                              _c("span", { staticClass: "tag-pt" }, [
                                _vm._v(
                                  "/ " + _vm._s(_vm.statusPt(row.sendStatus))
                                ),
                              ]),
                            ]
                          ),
                          row.sendStatus === 2 && row.errorMsg
                            ? _c("div", { staticClass: "al-err" }, [
                                _vm._v(" " + _vm._s(row.errorMsg) + " "),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("bi-label", {
                        attrs: { zh: "发送状态", pt: "Status do Envio" },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: {
                    width: "100",
                    align: "center",
                    "class-name": "cell-num",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [_vm._v(_vm._s(row.retryCount))]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("bi-label", {
                        attrs: { zh: "重试次数", pt: "Tentativas" },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: {
                    "min-width": "160",
                    "show-overflow-tooltip": "",
                    "class-name": "cell-num",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [_vm._v(_vm._s(row.alertId))]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _c("bi-label", {
                        attrs: { zh: "告警 ID", pt: "ID do Alerta" },
                      }),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c(
                "el-pagination",
                {
                  staticClass: "al-pagination",
                  attrs: {
                    "current-page": _vm.searchParam.pageNumber,
                    "page-size": _vm.searchParam.pageSize,
                    "page-sizes": [10, 20, 50],
                    total: _vm.total,
                    layout: "slot, sizes, prev, pager, next, jumper",
                  },
                  on: {
                    "update:currentPage": function ($event) {
                      return _vm.$set(_vm.searchParam, "pageNumber", $event)
                    },
                    "update:current-page": function ($event) {
                      return _vm.$set(_vm.searchParam, "pageNumber", $event)
                    },
                    "update:pageSize": function ($event) {
                      return _vm.$set(_vm.searchParam, "pageSize", $event)
                    },
                    "update:page-size": function ($event) {
                      return _vm.$set(_vm.searchParam, "pageSize", $event)
                    },
                    "current-change": _vm.handlePageChange,
                    "size-change": _vm.handleSizeChange,
                  },
                },
                [
                  _c("span", { staticClass: "pb-total" }, [
                    _vm._v(" 共 " + _vm._s(_vm.total) + " 条"),
                    _c("span", { staticClass: "pb-pt" }, [
                      _vm._v("/ Total: " + _vm._s(_vm.total) + " registros"),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("h2", { staticStyle: { "margin-top": "0" } }, [
        _vm._v(" 告警发送日志 "),
        _c("span", { staticClass: "h2-pt" }, [
          _vm._v("Log de Envios de Alertas"),
        ]),
      ]),
      _c("div", { staticClass: "desc" }, [
        _c("span", [
          _vm._v("所有触发的告警事件，包括发送渠道、接收群、发送状态"),
        ]),
        _c("span", { staticClass: "desc-pt" }, [
          _vm._v(
            " Todos os alertas disparados, incluindo canal de envio, grupo destinatário e status do envio "
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }